module.exports = __webpack_public_path__ + "static/img/pictureF.3bfd013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pictureF.jpg
// module id = v7F0
// module chunks = 0